import React from 'react'
import {
    Box,
} from '@chakra-ui/react'
// import './test.css';

const FacultyCards = () => {
    return (
        <Box style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minWidth: '310px',
            height: '500px',
            margin:'20px 0px 20px 0px',

        }}>
            <Box style={{
                width: '70vw',
                minWidth: '310px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                fontSize: '1.2rem',
                background: 'linear-gradient(to bottom right,#4B79A1, #283E51)',
                boxShadow: '10px 10px 50px rgba(0,0,0,0.7)',
                color: '#fffd',
                textAlign: 'center',
                fontWeight: 'bold',
                
            }}>
                <Box style={{
                    width: '100%', minWidth: '310px',
                    padding: '15px 15px 5px 15px',
                    fontSize: '1.75rem',
                    fontWeight: '800',
                    letterSpacing: '3px',
                    background: 'linear-gradient(rgba(255,255,255,0.1),rgba(255,255,255,0.1)'

                }}>
                    <center>Convener </center>
                </Box>
                <Box style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    padding: '15px'
                }}>
                    <Box style={{
                        width: '100%',
                        minWidth: '310px',
                        padding: '15px',
                        textTransform:'uppercase'
                    }}>
                        Prof. Vijay Attri
                    </Box>
                </Box>
                <Box style={{
                    width: '100%', minWidth: '310px',
                    padding: '15px 15px 5px 15px',
                    fontSize: '1.75rem',
                    fontWeight: '800',
                    letterSpacing: '3px',
                    background: 'linear-gradient(rgba(255,255,255,0.1),rgba(255,255,255,0.1)'

                }}>
                    <center>Members</center>
                </Box>
                <Box style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    padding: '15px'
                }}>
                    <Box style={{
                        width: '50%',
                        minWidth: '310px',
                        padding: '15px'
                    }}>
                        Prof. Archana Sharma
                    </Box>
                    <Box style={{
                        width: '50%',
                        minWidth: '310px',
                        padding: '15px'
                    }}>
                        Prof. Shivani Sharma
                    </Box>
                    <Box style={{
                        width: '50%',
                        minWidth: '310px',
                        padding: '15px'
                    }}>
                        Dr. Nisha Singh
                    </Box>
                    <Box style={{
                        width: '50%',
                        minWidth: '310px',
                        padding: '15px'
                    }}>
                        Prof. Kaushal Gupta
                    </Box>
                    <Box style={{
                        width: '50%',
                        minWidth: '310px',
                        padding: '15px'
                    }}>
                        Dr. Neeti Srivastav
                    </Box>
                    <Box style={{
                        width: '50%',
                        minWidth: '310px',
                        padding: '15px'
                    }}>
                        Prof. Monika Singh
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default FacultyCards